import { render, staticRenderFns } from "./ProcessMaterialList.vue?vue&type=template&id=1a1e6726&"
import script from "./ProcessMaterialList.vue?vue&type=script&lang=js&"
export * from "./ProcessMaterialList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports